import 'core-js';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { setPageTitle } from '@/utils/setTitle';
import { setLangToBodyClass } from '@/utils/setLangToBodyClass';
import DbMonitor from './views/page/DbMonitor.vue';
import filters from './utils/index';
import createBridge, { createEventHub } from '@patsnap-utils/store-connect';
import { PRESETS_TOKEN_BASE_INTEGRATE } from '../../../../components/token-base/presets';
import { startup } from '../../../../components/startup';
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import '@patsnap-biz/authority/src/style/authority.scss';

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import { ejectNodeApiInterceptor, passportInterceptManager, prepareTokenBase } from '../../../../components/token-base';
import { psAxios } from '@patsnap/common-ps-http';
import { merge, upperCase } from 'lodash';
import { setIsFreeViewDataCoverage } from './utils/dataCoverageUtil';
import qs from 'qs';

async function langGetter(lang) {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/cn.json'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/tw.json'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/en.json'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/jp.json'),
        ]);
    }
    const data = results.reduce((obj, data) => merge(obj, data), {});
    return { [lang]: data };
}

// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LegendComponent,
    LineChart,
    BarChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);

window.$bridge = createBridge({
    headerConfig: {
        inputType: 'noInput',
        moduleName: 'DataCoverage'
    }
});

Vue.prototype.$eventHub = createEventHub(window.$bridge);
Vue.prototype.$echarts = echarts;

Vue.use(VueI18n);
Object.keys(filters).forEach(k => {
    Vue.filter(k, filters[k]);
});

(async () => {
    // 给官网使用，语言根据url上的来
    const { lang = '' } = qs.parse(window.location.search.substring(1));

    // 提前 prepareToken 区分是否登录
    let isFreeView = false;
    setIsFreeViewDataCoverage(false);
    try {
        await prepareTokenBase({
            ...PRESETS_TOKEN_BASE_INTEGRATE,
            preRedirectLogin() {
                throw new Error('Anonymous');
            }
        });
    } catch (err) {
        if (err.message === 'Anonymous') {
            // 无 token 为 free 需要去除默认内置拦截器
            isFreeView = true;
            setIsFreeViewDataCoverage(true);
            passportInterceptManager.eject();
            ejectNodeApiInterceptor();
        }
    }

    let [headerService, locale] = await startup({
        projectName: 'Integrate',
        isFreeView: isFreeView,
        pageInit: () => {},
        forceSetLocale: lang
    });
    // 根据语言修改 title
    setPageTitle('status', locale, headerService.whiteLabel);


    // 设置body 关于lang的class
    setLangToBodyClass(locale);

    psAxios.interceptors.request.use(config => {
        config.headers['X-Site-Lang'] = upperCase(locale);
        return config;
    }, null);

    const messages = await langGetter(locale);


    window.hidePageLoading && window.hidePageLoading();


    const i18n = new VueI18n({
        locale,
        messages
    });

    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        i18n,
        render() {
            return <div>
                <DbMonitor />
            </div>;
        }
    });
})();
